<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Atp7OK/tc-custom/9781460349335.jpg?1726444269700" alt="This image is the cover for the book Scandalous Lord Lanchester"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Scandalous Lord Lanchester
      </h1>
      <p class="bookDescription body article font2">
        <p>Marrying the Governess!<br/><br/>Buttoned-up governess Daisy Milton buries dreams of marriage and family life in order to support her sister and orphaned niece. But maddeningly attractive Adam, Viscount Ravensworth, is one distraction that shakes Daisy’s safe, stable existence. Now ghosts from Adam’s past in India threaten Daisy’s future. Just what will it take to convince a tightly laced miss to forgo society’s strict code of conductand come undone in the arms of a reformed rake?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anne Herries
      </h2>
      
      <p class="authorDescription body article">Linda Sole was started writing in 1976 and writing as Anne Herries, won the 2004 RNA Romance Award and the Betty Neels Trophy. Linda loves to write about the beauty of nature, though they are mostly about love and romance. She writes for her own enjoyment and loves to give pleasure to her readers. In her spare time, she enjoys watching the wildlife that visits her garden. Anne has now written more&#160; fifty books for HMB.&#160; You can visit her website at: www.lindasole.co.u</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4750c87c